/**
 * Instruction to disclose information or to use default value of the receiver.
 * tag: 1814
 * @readonly
 * @enum {number} (int)
 */
export enum DisclosureInstruction {
  /** No */
  No = 0,
  /** Yes */
  Yes = 1,
  /** Use default setting */
  UseDefaultSetting = 2,
}
